<template>
    <vx-card class="overflow-hidden shadow-none">
        <div slot="no-body">
            <div class="py-6 px-2 text-center">
                <img :src="iconPath" width="50px" class="p-3 inline-flex">
                <div class="text-sm">
                    <span>{{ title }}</span>
                </div>
            </div>
        </div>
    </vx-card>
</template>

<script>

export default{
    props: {
        icon: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        }
    },
    computed: {
        iconPath: function() {
            try{
                return require(`@/assets/images/icons/icon_backend_${this.icon}.svg`)
            } catch (e) {
                console.error(e)
                return '';
            }
        }
    }
}
</script>
